import { useState } from 'react';
import * as S from './style';
import company from '@/assets/img/company.jpg';
import uuid from 'react-uuid';
const History = () => {
	const [date, setDate] = useState('2020’s');
	const dateList = ['2020’s', '2010’s', '2000’s', '1990’s', '1980’s'];
	const movetToContent = (tab: string) => {
		requestAnimationFrame(() => {
			const target = document.getElementById(tab)?.offsetTop ?? 0;
			const headerHeight = document.getElementById('header')?.offsetHeight ?? 0;
			const targetScroll = target - headerHeight - 50;
			window.scrollTo({
				top: targetScroll,
			});
		});
	};
	const onClickTabBar = (tab: string) => {
		movetToContent(tab);
		setDate(tab);
	};
	return (
		<S.HistoryContainer>
			<S.HistoryDateList>
				{dateList.map((d) => (
					<S.HistoryDate key={uuid()} className={d === date ? 'active' : ''} onClick={() => onClickTabBar(d)}>
						{d}
					</S.HistoryDate>
				))}
			</S.HistoryDateList>
			<S.HistoryContentWrapper id="2020’s">
				<S.HistoryImgBox bgImg={'//cdn.quv.kr/dftb6osy3%2Fup%2F6626031003e5a_1920.jpg'} />
				<S.HistoryContentBox>
					<S.HistoryContentMainTitle>2020’s</S.HistoryContentMainTitle>
					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>2026</S.HistoryContentTitle>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>01월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>제 29대 회장 이재원 교수 취임</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>
					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>2025</S.HistoryContentTitle>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>10월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>
								24일 2025년 한국노화학회 추계학술대회 및 (사)한국노인과학학술단체연합회 학술대회(서울아산병원)
							</S.HistoryContentDescription>
							<S.HistoryContentDescription>한국노화학회 소식지 18호 발간</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>06월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>23일~24일 43회 2025 춘계학술대회 (인하대학교 항공우주산학융합원)</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>05월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>한국노인과학학술단체연합회-국립보건연구원 MOU 체결</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>01월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>제 28대 회장 민경진 교수 취임</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>
					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>2024</S.HistoryContentTitle>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>10월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>
								2024년 한국노화학회 추계학술대회 및 (사)한국노인
								<br />
								과학학술단체연합회 학술대회(서울아산병원)
							</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>07월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>
								41회 2024한국노화학회 춘계학술대회
								<br />
								(영등포 한강성심병원 도헌 연구센터)
							</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>01월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>제 27대 회장 최은경 교수 취임</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>
					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>2023</S.HistoryContentTitle>
						<S.HistoryContentSubTitle>10월</S.HistoryContentSubTitle>
						<S.HistoryContentDescription>
							2023년 한국노화학회 추계학술대회 및 (사)한국노인
							<br />
							과학학술단체연합회 학술대회 (서울아산병원)
						</S.HistoryContentDescription>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>07월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>
								40회 2023한국노화학회 춘계학술대회 및 한일
								<br />
								노화학회 (고려대학교 백주년기념관)
							</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>01월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>제 26대 회장 이철구 교수 취임</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>
					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>2022</S.HistoryContentTitle>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>12월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>39회 2022년 한국노화학회 추계학술대회 (고려대학교 백주년기념관)</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>10월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>
								2022 International Society for Gerontechnology / (사)한국노인과학학술단체연합회 학술심포지엄 (대구 엑스코)
							</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>09월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>게놈바이오엑스포 2022 (UECO 울산컨벤션센터)</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>07월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>한일노화학회 (일본 교토 테르사)</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>06월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>
								제200회 한림원탁토론회: 벤자민 버튼의 시간, 노화의 비밀을 넘어 역노화에 도전 (엘타워 골드홀)
							</S.HistoryContentDescription>
							<S.HistoryContentDescription>한국노화학회 PI 워크샵 (DGIST)</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>01월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>제25대 회장 박중진 교수 취임</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>
					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>2021</S.HistoryContentTitle>
						<S.HistoryContentSubTitle>06월</S.HistoryContentSubTitle>
						<S.HistoryContentDescription>38회 2021 춘계학술대회 (인하대학교60주년 기념관)</S.HistoryContentDescription>
					</S.HistoryContentItemBox>
					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>2020</S.HistoryContentTitle>
						<S.HistoryContentSubTitle>11월</S.HistoryContentSubTitle>
						<S.HistoryContentDescription>37회 2020 추계학술대회 (인하대학교60주년 기념관)</S.HistoryContentDescription>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>01월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>제24대 회장 이성근 교수 취임</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>
				</S.HistoryContentBox>
			</S.HistoryContentWrapper>
			<S.HistoryContentWrapper id="2010’s">
				<S.HistoryImgBox bgImg={'//cdn.quv.kr/dftb6osy3%2Fup%2F662611ec5330e_1920.jpg'} />
				<S.HistoryContentBox>
					<S.HistoryContentMainTitle>2010’s</S.HistoryContentMainTitle>
					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>2019</S.HistoryContentTitle>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>01월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>제23대 회장 정인권 교수 취임</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>
					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>2018</S.HistoryContentTitle>
						<S.HistoryContentSubTitle>01월</S.HistoryContentSubTitle>
						<S.HistoryContentDescription>제22대 회장 권기선 박사 취임</S.HistoryContentDescription>
					</S.HistoryContentItemBox>
					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>2017</S.HistoryContentTitle>
						<S.HistoryContentSubTitle>11월</S.HistoryContentSubTitle>
						<S.HistoryContentDescription>
							3일 32회 2017추계학술대회 및 총회
							<br />
							(서울시립대학교 자연과학관 대회의실)
						</S.HistoryContentDescription>
						<S.HistoryContentDescription>한국노화학회 소식지 10호 발간</S.HistoryContentDescription>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>06월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>
								22일~23일 31회 2017춘계학술대회
								<br />
								(숙명여자대학교 잼마홀)
							</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>01월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>제21대 회장 김현숙 교수 취임</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>
					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>2016</S.HistoryContentTitle>
						<S.HistoryContentSubTitle>11월</S.HistoryContentSubTitle>
						<S.HistoryContentDescription>
							25일 30회 2016추계학술대회 및 총회 <br />
							(서울시립대학교 미래관)
						</S.HistoryContentDescription>
						<S.HistoryContentDescription>한국노화학회 소식지 9호 발간</S.HistoryContentDescription>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>06월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>
								15일~17일 29회 2016국제춘계학술대회 <br />
								(대구호텔라온제나)
							</S.HistoryContentDescription>
							<S.HistoryContentDescription>한국노화학회 소식지 8호 발간</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>01월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>제20대 회장 김재룡 교수 취임</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>
					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>2015</S.HistoryContentTitle>
						<S.HistoryContentSubTitle>11월</S.HistoryContentSubTitle>
						<S.HistoryContentDescription>
							13일 28회 2015추계학술대회
							<br />
							(서울시립대학교 자연과학관)
						</S.HistoryContentDescription>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>06월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>
								13일~14일 한일노화학회공동심포지엄
								<br />
								(일본 Pacifico yokohama)
							</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>05월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>29일 27회 2015춘계학술대회(대전생명공학연구원)</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>01월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>제19대 회장 신득용 교수 취임</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>
					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>2014</S.HistoryContentTitle>
						<S.HistoryContentSubTitle>11월</S.HistoryContentSubTitle>
						<S.HistoryContentDescription>21일 추계학술대회(서울시립대학교 미래관)</S.HistoryContentDescription>
						<S.HistoryContentDescription>한국노화학회 소식지 7호 발간</S.HistoryContentDescription>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>06월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>
								19일~21일 춘계 국제학술대회 및 한일노화학회
								<br />
								공동심포지엄(제주 누가빌리지)
							</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>
					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>2013</S.HistoryContentTitle>
						<S.HistoryContentSubTitle>11월</S.HistoryContentSubTitle>
						<S.HistoryContentDescription>7일~8일 추계학술대회(서울시립대학교 자연과학관)</S.HistoryContentDescription>
						<S.HistoryContentDescription>한국노화학회 소식지 6호 발간</S.HistoryContentDescription>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>06월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>
								23일~27일 제20차 세계노년학노인의대회
								<br />
								(IAGG2013) 참석(서울 코엑스)
							</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>01월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>제18대 회장 황은성 교수 취임</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>
					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>2012</S.HistoryContentTitle>
						<S.HistoryContentSubTitle>11월</S.HistoryContentSubTitle>
						<S.HistoryContentDescription>23일 추계 학술대회(서울시립대학교 자연과학관)</S.HistoryContentDescription>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>06월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>14일~15일 춘계 학술대회(오송 국립보건원)</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>01월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>제17대 회장 김응국 교수 취임</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>
					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>2011</S.HistoryContentTitle>
						<S.HistoryContentSubTitle>11월</S.HistoryContentSubTitle>
						<S.HistoryContentDescription>추계학술대회(서울시립대학교 자연과학관)</S.HistoryContentDescription>
						<S.HistoryContentDescription>한국노화학회 소식지 4호 발간</S.HistoryContentDescription>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>07월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>춘계 국제학술대회(부산 농심호텔)</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>01월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>제16대 회장 정해영 교수 취임</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>
					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>2010</S.HistoryContentTitle>
						<S.HistoryContentSubTitle>11월</S.HistoryContentSubTitle>
						<S.HistoryContentDescription>30일 한국노화학회 소식지 3호 발간</S.HistoryContentDescription>
						<S.HistoryContentDescription>2010 26일 추계학술대회(서울시립대학교 자연과학관)</S.HistoryContentDescription>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>07월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>2010 춘계학술대회(한국생명공학연구원)</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>01월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>제15대 회장 이재용 교수 취임</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>
				</S.HistoryContentBox>
			</S.HistoryContentWrapper>
			<S.HistoryContentWrapper id="2000’s">
				<S.HistoryImgBox bgImg={'//cdn.quv.kr/dftb6osy3%2Fup%2F6630a18920417_1920.jpg'} />
				<S.HistoryContentBox>
					<S.HistoryContentMainTitle>2000’s</S.HistoryContentMainTitle>
					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>2009</S.HistoryContentTitle>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>11월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>한국노화학회 소식지 2호 발간</S.HistoryContentDescription>
							<S.HistoryContentDescription>
								20일 2009 추계학술대회
								<br />
								(서울시립대학교 본관 대강당)
							</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>07월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>
								5일~9일 2013 서울 IAGG대회 홍보 일환으로
								<br /> 파리 IAGG 대회 참가
							</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>05월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>한국노화학회 소식지 창간(연2회 발행)</S.HistoryContentDescription>
							<S.HistoryContentDescription>14일 2009 춘계학술대회 (아주대학교 병원 대강당)</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>01월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>제14대 회장 임인경 교수 취임</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>
					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>2008</S.HistoryContentTitle>
						<S.HistoryContentSubTitle>11월</S.HistoryContentSubTitle>
						<S.HistoryContentDescription>
							21일 한국노인과학학술단체연합회
							<br />
							국제학술대회(서울백범기념관)
						</S.HistoryContentDescription>
						<S.HistoryContentDescription>
							3일 추계학술대회 및 노화고령사회연구소 심포지움
							<br />
							(서울대학교 함춘강의실)
						</S.HistoryContentDescription>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>06월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>24일 노화학 연구 집담회(서울대생화학교실)</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>05월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>
								15일~16일 2008 춘계학술대회 및<br />
								제8차 한일교류학술대회(영남대학교 축성강의실)
							</S.HistoryContentDescription>
							<S.HistoryContentDescription>9일 노화학 연구 집담회(서울대 생화학교실)</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>01월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>제13대 회장 김정희 교수 취임</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>
					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>2007</S.HistoryContentTitle>
						<S.HistoryContentSubTitle>05월</S.HistoryContentSubTitle>
						<S.HistoryContentDescription>
							11일 2007 춘계학술대회
							<br />
							(전남대학교 의과대학 덕재홀)
						</S.HistoryContentDescription>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>01월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>제12대 회장 지은정 교수 취임</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>
					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>2006</S.HistoryContentTitle>
						<S.HistoryContentSubTitle>12월</S.HistoryContentSubTitle>
						<S.HistoryContentDescription>
							15일 2006 추계학술대회
							<br />
							(한림대학교 일송빌딩 문화홀)
						</S.HistoryContentDescription>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>10월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>
								27일 2006서울국제노년학술회의 및<br />
								추계연합학술대회(양재동 AT센터)
							</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>06월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>
								22일 2006 춘계학술대회 제6차 한일교류학술대회
								<br />
								(강원대학교 정보통신연구소)
							</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>01월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>제11대 회장 김용선 교수 취임</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>
					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>2005</S.HistoryContentTitle>
						<S.HistoryContentSubTitle>06월</S.HistoryContentSubTitle>
						<S.HistoryContentDescription>10일 2005 춘계학술대회(이화여대 SK텔레콤관)</S.HistoryContentDescription>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>01월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>제10대 회장 김화영 교수 취임</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>
					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>2004</S.HistoryContentTitle>
						<S.HistoryContentSubTitle>11월</S.HistoryContentSubTitle>
						<S.HistoryContentDescription>
							11일 2004 추계학술대회 및 총회(서울의대 강당)
							<br />
							&quot;Diet, Health and Longevity&quot;
						</S.HistoryContentDescription>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>10월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>국제 백세인 심포지움, 순창군과 함께 주관</S.HistoryContentDescription>
						</S.HistoryContentItem>

						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>06월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>
								24일~26일 춘계학술대회 및 한일교류학술대회
								<br />
								(한림대 생명과학관)
							</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>01월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>제9대 회장 성상철 교수 취임</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>
					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>2003</S.HistoryContentTitle>
						<S.HistoryContentSubTitle>04월</S.HistoryContentSubTitle>
						<S.HistoryContentDescription>11일~12일 춘계학술대회(영남대 국제관)</S.HistoryContentDescription>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>01월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>제8대 회장 허 근 교수 취임</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>
					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>2002</S.HistoryContentTitle>
						<S.HistoryContentSubTitle>11월</S.HistoryContentSubTitle>
						<S.HistoryContentDescription>8일~9일 2002 학술대회 및 총회(서울의대 분관)</S.HistoryContentDescription>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>07월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription> 춘계학술대회 및 한일교류학술대회(연세대 상남경영관)</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>
					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>2001</S.HistoryContentTitle>
						<S.HistoryContentSubTitle>11월</S.HistoryContentSubTitle>
						<S.HistoryContentDescription>
							2일~3일 2001 학술대회 및 총회(서울의대 강당)
							<br />
							&quot;백세노인과 장수문화&quot;
						</S.HistoryContentDescription>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>07월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>20일 노화학 연구 집담회(전남대 의대)</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>06월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>13일~15일 한일노화학술교류 일환으로 일본 기초 노화학학술대회 참가</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>05월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>12일 춘계학술대회(한국과학기술원 의과학연구센터)</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>04월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>20일 노화학 연구 집담회(서울대 생화학교실)</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>03월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>30일 노화학 연구 집담회(서울대 생화학교실)</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>02월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>24일 노화학 연구 집담회(수안보 상록회관)</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>01월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>제7대 회장 정안식 교수 취임</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>
					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>2000</S.HistoryContentTitle>
						<S.HistoryContentSubTitle>10월</S.HistoryContentSubTitle>
						<S.HistoryContentDescription>17일 2000 학술대회 및 총회(서울대 의대 강당)</S.HistoryContentDescription>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>08월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>
								10일 하계노화학연구 집담회(부경대)
								<br />
								&quot;Stress Response and Aging&quot;
							</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>05월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>
								27일 춘계노화학회 개최(서울대의대 분관)
								<br />
								&quot;Oxidative Stress와 항노화식품&quot;
							</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>02월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>
								21일~24일 제8회 국제노화학회(IABMG)
								<br />
								국내 개최(경주)
							</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>01월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>제6대 회장 정명희 교수 취임</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>
				</S.HistoryContentBox>
			</S.HistoryContentWrapper>
			<S.HistoryContentWrapper id="1990’s">
				<S.HistoryImgBox bgImg={'//cdn.quv.kr/dftb6osy3%2Fup%2F6630a1dda7062_1920.jpg'} />
				<S.HistoryContentBox>
					<S.HistoryContentMainTitle>1990’s</S.HistoryContentMainTitle>
					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>1999</S.HistoryContentTitle>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>06월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>
								8일~11일 제6회 아시아-오세아니아
								<br />
								노년학대회 개최(서울)
							</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>
					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>1998</S.HistoryContentTitle>
						<S.HistoryContentSubTitle>01월</S.HistoryContentSubTitle>
						<S.HistoryContentDescription>제5대 회장 박상철 교수 취임</S.HistoryContentDescription>
					</S.HistoryContentItemBox>
					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>1997</S.HistoryContentTitle>
						<S.HistoryContentSubTitle>05월</S.HistoryContentSubTitle>
						<S.HistoryContentDescription>
							21일 한국노년학회, 한국노인병학회와 함께
							<br />
							(사)한국노인과학학술단체연합회설립
						</S.HistoryContentDescription>
						<S.HistoryContentDescription>1997학회지 전문 검색 서비스개시(보건연구정보센터)</S.HistoryContentDescription>
					</S.HistoryContentItemBox>
					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>1996</S.HistoryContentTitle>
						<S.HistoryContentSubTitle>06월</S.HistoryContentSubTitle>
						<S.HistoryContentDescription>28일 제1회 알긴산 국제학술대회 개최</S.HistoryContentDescription>
						<S.HistoryContentDescription>{`1996 한국노화학회지 연2회 -> 연3회 발간`}</S.HistoryContentDescription>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>01월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>제4대 회장 최진호 교수 취임</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>
					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>1994</S.HistoryContentTitle>
						<S.HistoryContentSubTitle>01월</S.HistoryContentSubTitle>
						<S.HistoryContentDescription>제3대 회장 양 융 교수 취임</S.HistoryContentDescription>
					</S.HistoryContentItemBox>
					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>1992</S.HistoryContentTitle>
						<S.HistoryContentSubTitle>01월</S.HistoryContentSubTitle>
						<S.HistoryContentDescription>제2대 회장 고창순 교수 취임</S.HistoryContentDescription>
					</S.HistoryContentItemBox>
					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>1991</S.HistoryContentTitle>
						<S.HistoryContentSubTitle>02월</S.HistoryContentSubTitle>
						<S.HistoryContentDescription>한국노화학회지 창간</S.HistoryContentDescription>
					</S.HistoryContentItemBox>
					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>1990</S.HistoryContentTitle>
						<S.HistoryContentSubTitle>01월</S.HistoryContentSubTitle>
						<S.HistoryContentDescription>초대회장 이민화 교수 취임</S.HistoryContentDescription>
					</S.HistoryContentItemBox>
				</S.HistoryContentBox>
			</S.HistoryContentWrapper>

			<S.HistoryContentWrapper id="1980’s">
				<S.HistoryImgBox bgImg={'//cdn.quv.kr/dftb6osy3%2Fup%2F6630a26d28905_1920.jpg'} />
				<S.HistoryContentBox>
					<S.HistoryContentMainTitle>1980’s</S.HistoryContentMainTitle>
					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>1989</S.HistoryContentTitle>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>11월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>
								연세대 100주년 기념관에서 창립총회 및<br />
								제1회 학술발표대회 개최
							</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>
				</S.HistoryContentBox>
			</S.HistoryContentWrapper>
		</S.HistoryContainer>
	);
};
export default History;
